
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/create/policy",
      function () {
        return require("private-next-pages/create/policy/index.ts");
      }
    ]);
  